import styled from '@emotion/styled';

import { FONT } from '../../../../styles/emotion';

export const Container = styled.div<{ isMidInquiryFlowAuth?: boolean }>`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_EXTRA_SMALL)}
  padding-top: 20px;
  text-align: ${(props) => (props.isMidInquiryFlowAuth ? 'left' : 'center')};
`;
